module.exports = __webpack_public_path__ + "static/media/Group 759.1d195c1e.svg";